"use client";

import { useDisallowInspect } from "@/hooks/useDisallowInspect";
import { ReactNode } from "react";

export const InspectionGuard = ({ children }: { children: ReactNode }) => {
  useDisallowInspect();

  return <>{children}</>;
};
